// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingSpinner_loadingContainer__DBpwW","spinner":"LoadingSpinner_spinner__F06y+","spin":"LoadingSpinner_spin__Qwth8","message":"LoadingSpinner_message__vuUvg"};